import { useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import api from "../lib/api";
import { Shell } from "./ForgotPassword";
import PasswordField, { passwordChecks } from "../components/PasswordField";

export default function AcceptInvitation() {
  const { t, lang } = useI18n();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState("");
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(false);
  const confirmRef = useRef(null);
  const inFlight = useRef(false);
  const valid = Object.values(passwordChecks(pw)).every(Boolean) && pw === confirm;
  const submit = async (e) => {
    e.preventDefault();
    if (inFlight.current || !valid || !token) return;
    if (pw !== confirm) { setMsg(lang === "de" ? "Die Passwörter stimmen nicht überein." : "Passwords do not match."); return; }
    inFlight.current = true; setLoading(true); setMsg("");
    try { const { data } = await api.post("/auth/accept-invitation", { token, password: pw }); setMsg(data.message); setOk(true); }
    catch { setMsg(t("inviteBad")); }
    finally { inFlight.current = false; setLoading(false); }
  };
  return (
    <Shell title={t("inviteTitle")} sub={t("inviteSub")}>
      {!ok && <form onSubmit={submit} className="space-y-4" data-testid="invite-form">
        <PasswordField data-testid="invite-password" autoComplete="new-password" enterKeyHint="next" placeholder={t("newPassword")} value={pw} onChange={(e) => setPw(e.target.value)} onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); confirmRef.current?.focus(); confirmRef.current?.scrollIntoView({ block: "center", behavior: "smooth" }); } }} required minLength={8} showRules lang={lang} />
        <PasswordField inputRef={confirmRef} data-testid="invite-password-confirm" autoComplete="new-password" enterKeyHint="go" placeholder={lang === "de" ? "Passwort wiederholen" : "Repeat password"} value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} lang={lang} />
        <button data-testid="invite-submit" className="pc-btn pc-btn-primary w-full" disabled={loading || !token || !valid}>{loading ? "…" : t("activate")}</button>
      </form>}
      {msg && <p data-testid="invite-msg" className="mt-4 text-sm" style={{ color: ok ? "var(--pc-cyan)" : "#ff8080" }}>{msg}</p>}
      <button onClick={() => nav("/login")} className="mt-6 text-sm" style={{ color: "var(--pc-cyan)", background: "none", border: "none", cursor: "pointer" }}>{t("backToLogin")}</button>
    </Shell>
  );
}
